import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import View from './View';
import config from '@plone/volto/registry';
import Sidebar from './Sidebar';

const Edit = (props) => {
  const { blocksConfig, data, onChangeBlock, block, selected } = props;

  const unwantedButtons = blocksConfig.introduction.unwantedButtons;
  const filteredToolbarProps = {
    ...props,
    slateSettings: {
      ...config.settings.slate,
      toolbarButtons: config.settings.slate.toolbarButtons
        .filter((button) => !unwantedButtons.includes(button))
        // remove any adjacent separators
        .filter((button, index, array) => button !== array[index + 1]),
    },
  };

  return (
    <>
      <View
        data={data}
        isEditMode={true}
        filteredToolbarProps={filteredToolbarProps}
      />

      <SidebarPortal selected={selected}>
        <Sidebar
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};
export default Edit;
